import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/projects/architectural-visualization/client-page.tsx");
